export default "__VITE_ASSET__b9b6c3b4__"